import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Api from '../../../Api';
import { Modal, Input, Button } from '../../../components';
import './style.css';

export default function NewExecutionModal({ isOpen, onClose, serviceOrder, companyId, onSuccess }) {
  const [observation, setObservation] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!serviceOrder) return;

    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem('authUser') || '{}');

      const payload = {
        service_order_id: serviceOrder.id,
        executor_id: user.id || null,
        executor_type: 'user',
        executor_name: user.name || '',
        observation_before: observation || null,
        photos: [],
      };

      const result = await Api.createServiceOrderExecution(companyId, payload);
      if (result && !result.error) {
        toast.success('Execução iniciada!');
        onSuccess(result);
        setObservation('');
      } else {
        toast.error(result?.error || 'Erro ao iniciar execução.');
      }
    } catch (error) {
      console.error(error);
      toast.error('Erro ao iniciar execução.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Nova Execução">
      {serviceOrder && (
        <form onSubmit={handleSubmit} className="company-form-component">
          <div className="form-body">
            <h3 className="section-title" style={{ marginTop: 0 }}>Dados da Ordem</h3>
            <div className="so-detail-grid">
              <div className="so-detail-item">
                <span className="so-detail-label">Ordem</span>
                <span className="so-detail-value">{serviceOrder.target_name || `OS #${serviceOrder.id}`}</span>
              </div>
              <div className="so-detail-item">
                <span className="so-detail-label">Tipo de Serviço</span>
                <span className="so-detail-value">{serviceOrder.service_type}</span>
              </div>
              <div className="so-detail-item">
                <span className="so-detail-label">Solicitação</span>
                <span className="so-detail-value">{serviceOrder.request_type}</span>
              </div>
              <div className="so-detail-item">
                <span className="so-detail-label">Serviços</span>
                <span className="so-detail-value">
                  {serviceOrder.services ? serviceOrder.services.map(s => s.name).join(', ') : '-'}
                </span>
              </div>
            </div>

            <div className="form-grid" style={{ gridTemplateColumns: '1fr', marginTop: '1.25rem' }}>
              <Input
                id="observation"
                label="Observação Inicial"
                value={observation}
                onChange={e => setObservation(e.target.value)}
                multiline
                rows={3}
              />
            </div>
          </div>

          <div className="modal-actions">
            <Button type="button" className="cancel-button" onClick={onClose}>Cancelar</Button>
            <Button type="submit" disabled={loading}>
              {loading ? 'Iniciando...' : 'Iniciar Execução'}
            </Button>
          </div>
        </form>
      )}
    </Modal>
  );
}
